import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import * as moment from "moment-timezone";
import { of, combineLatest, Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";

@Component({
  selector: 'app-timezone-dropdown',
  templateUrl: './timezone-dropdown.component.html',
  styleUrls: ['./timezone-dropdown.component.css']
})
export class TimezoneDropdownComponent implements OnInit, OnDestroy {
  @Input() timezoneControl!: FormControl;
  @Input() fieldLabel = "Timezone";
  @Output() selectionChange = new EventEmitter<string>();

  private subs = new SubSink();
  tzList: string[] = moment.tz.names();
  filterControl = new FormControl();
  formValue$: Observable<string>;
  finalDropdown$: Observable<string[]>;
  initialDropdown$: Observable<string[]> = of(this.tzList);

  ngOnInit() {
    // formValues are only populated in the ngOnInit lifecycle hook
    this.formValue$ = this.filterControl.valueChanges.pipe(
      startWith(<string>null), // this string cast is just to avoid the linter from complaining
      debounceTime(300),
      distinctUntilChanged(),
    );

    this.finalDropdown$ = combineLatest([this.initialDropdown$, this.formValue$]).pipe(
      map(([tzList, search]) => search
        ? tzList.filter(tz => tz.toLocaleLowerCase().includes(search?.toLocaleLowerCase()))
        : tzList
      )
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

